import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from "prop-types";
import React from "react";
import Modal from "react-modal";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import requester from "web/script/modules/requester";
import userProfiler from "web/script/modules/userprofiler";
import browser from "web/script/utils/browser";
import history from "web/script/utils/history";
import storage from "web/script/utils/storage";
import url from "web/script/utils/url";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import Button from "web/react/components/button/button";
import EmailCaptureForm from "web/react/components/email-capture-form/email-capture-form";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./recently-viewed-email-capture.css";
export var RecentlyViewedEmailCapture =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RecentlyViewedEmailCapture, _React$Component);

  function RecentlyViewedEmailCapture() {
    var _this;

    _classCallCheck(this, RecentlyViewedEmailCapture);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RecentlyViewedEmailCapture).call(this));
    _this.state = {
      emailAddress: "",
      formErrors: undefined,
      imageUrls: [],
      marketingEmails: false,
      overlayOpen: false,
      privacyPolicy: false,
      productIds: [],
      showDone: false
    };
    _this.appElement = React.createRef();
    _this.fetchImageUrls = _this.fetchImageUrls.bind(_assertThisInitialized(_this));
    _this.changeEmail = _this.changeEmail.bind(_assertThisInitialized(_this));
    _this.triggerClose = _this.triggerClose.bind(_assertThisInitialized(_this));
    _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
    _this.onContinueShoppingClick = _this.onContinueShoppingClick.bind(_assertThisInitialized(_this));
    _this.handleLegalChange = _this.handleLegalChange.bind(_assertThisInitialized(_this));
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RecentlyViewedEmailCapture, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var queryParams = history.getCurrentQueryParams(); // Don't show recently viewed email capture if:
      //  - user has already seen email capture
      //  - user is not a returning user
      //  - atc_campaign tag is set to "paid-signups" (meaning user landed on FB product overlay)

      if (storage.get("recentlyViewedEmailCaptureShown") === true || userProfiler.getRecentlyViewedEmailCaptureShown() === true || !analytics.isReturningUser() || queryParams.get("atc_campaign") === "paid-signups") {
        return null;
      }

      var seenProducts = userProfiler.getSeenProducts();

      if (!seenProducts || seenProducts.length === 0) {
        return null;
      }

      var ids = seenProducts.map(function (product) {
        return product.productId;
      }).splice(0, 3);
      this.setState({
        productIds: ids
      }); // If viewing on mobile and mobile version is enabled, show the mobile version

      if (browser.getViewport() === browser.VIEWPORTS.MOBILE) {
        return null;
      } else if (this.props.desktopVersionEnabled === true) {
        // Show desktop for tablet and desktop and if desktop version is enabled
        Modal.setAppElement(this.appElement.current);
        setTimeout(this.fetchImageUrls, 1000, ids);
      }

      disableBodyScroll(this.appElement.current);
    }
  }, {
    key: "fetchImageUrls",
    value: function () {
      var _fetchImageUrls = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(ids) {
        var query, jsonData, validResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = {
                  product_ids: ids
                };
                jsonData = undefined;
                _context.prev = 2;
                _context.next = 5;
                return requester.get("/api/product/images/", query);

              case 5:
                jsonData = _context.sent;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                console.error(_context.t0);
                return _context.abrupt("return");

              case 12:
                validResponse = jsonData && jsonData.success && jsonData.data;

                if (validResponse) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return");

              case 15:
                this.setState({
                  imageUrls: jsonData.data.image_urls || [],
                  overlayOpen: true
                });
                analytics.event("signup_recent", "open_signup_form", "open_overlay");
                storage.set("recentlyViewedEmailCaptureShown", true);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function fetchImageUrls(_x) {
        return _fetchImageUrls.apply(this, arguments);
      }

      return fetchImageUrls;
    }()
  }, {
    key: "changeEmail",
    value: function changeEmail(event) {
      this.setState({
        emailAddress: event.target.value
      });
    }
  }, {
    key: "triggerClose",
    value: function triggerClose() {
      this.setState({
        overlayOpen: false
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      if (this.state.showDone) {
        analytics.event("signup_recent", "close_signup_form_screen_2", "exit_signup");
      } else {
        analytics.event("signup_recent", "close_signup_form_screen_1", "exit_signup", true); // non interactive
      }

      clearAllBodyScrollLocks();
      this.triggerClose();
    }
  }, {
    key: "onContinueShoppingClick",
    value: function onContinueShoppingClick() {
      analytics.event("signup_recent", "click_continue_button", "continue_button");
      this.triggerClose();
    }
  }, {
    key: "handleLegalChange",
    value: function handleLegalChange(privacyPolicyChecked, marketingEmailsChecked) {
      var _this$state = this.state,
          privacyPolicy = _this$state.privacyPolicy,
          marketingEmails = _this$state.marketingEmails; // LegalAgreement component can call this on every render, so we need to check that we don't
      // call setState only when necessary

      if (privacyPolicy !== privacyPolicyChecked || marketingEmails !== marketingEmailsChecked) {
        this.setState({
          privacyPolicy: privacyPolicyChecked,
          marketingEmails: marketingEmailsChecked
        });
      }
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(event) {
        var _this$state2, productIds, emailAddress, marketingEmails, privacyPolicy, productId, body, jsonData, queryParams, errors;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                event.preventDefault();
                _this$state2 = this.state, productIds = _this$state2.productIds, emailAddress = _this$state2.emailAddress, marketingEmails = _this$state2.marketingEmails, privacyPolicy = _this$state2.privacyPolicy;
                analytics.event("signup_recent", "click_signup_button", "signup_button");
                productId = productIds.splice(0, 1)[0];
                body = {
                  product_id: productId,
                  invisible_pids: productIds.join(","),
                  email: emailAddress,
                  marketing_emails: marketingEmails,
                  privacy_policy: privacyPolicy
                };
                jsonData = undefined;
                queryParams = url.toQueryString({
                  type: "save_for_later_recent",
                  product_id: productId,
                  email_capture: "true"
                }).toString();
                _context2.prev = 7;
                _context2.next = 10;
                return requester.post("/account/register/?".concat(queryParams), body);

              case 10:
                jsonData = _context2.sent;
                _context2.next = 18;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](7);
                console.error(_context2.t0);
                this.setState({
                  formErrors: {
                    other: [gettext("account.login.with_magic_link.error_title")]
                  }
                });
                return _context2.abrupt("return");

              case 18:
                if (jsonData && jsonData.success) {
                  this.setState({
                    showDone: true
                  });
                  analytics.event("signup_recent", "show_success_screen", "open_overlay");
                } else {
                  errors = jsonData.data.errors;
                  this.setState({
                    formErrors: errors
                  });
                }

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 13]]);
      }));

      function onSubmit(_x2) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cookiePolicyLink = _this$props.cookiePolicyLink,
          privacyPolicyLink = _this$props.privacyPolicyLink,
          termsAndConditionsLink = _this$props.termsAndConditionsLink;
      var shortPolicy = this.props.shortPolicy;
      var _this$state3 = this.state,
          emailAddress = _this$state3.emailAddress,
          formErrors = _this$state3.formErrors,
          imageUrls = _this$state3.imageUrls,
          overlayOpen = _this$state3.overlayOpen,
          showDone = _this$state3.showDone;
      var images = imageUrls.map(function (imageUrl) {
        return React.createElement("img", {
          key: imageUrl,
          className: styles.image,
          src: imageUrl
        });
      });
      var form = React.createElement("div", null, React.createElement("div", {
        className: styles.header
      }, React.createElement("h3", {
        className: styles.title
      }, gettext("account.register.return_lead.recently_viewed_items.step2_title")), React.createElement("div", {
        className: styles.subtitle
      }, gettext("account.register.return_lead.recently_viewed_items.step2_subtitle"))), React.createElement("div", {
        className: styles.images
      }, images), React.createElement(EmailCaptureForm, {
        captureType: "signup_recent",
        cookiePolicyLink: cookiePolicyLink,
        emailAddress: emailAddress,
        emailLabelText: gettext("account.register.return_lead.recently_viewed_items.email_label"),
        formErrors: formErrors,
        onEmailChange: this.changeEmail,
        onLegalChange: this.handleLegalChange,
        onSubmit: this.onSubmit,
        privacyPolicyLink: privacyPolicyLink,
        submitText: gettext("account.register.return_lead.recently_viewed_items.step2_btn"),
        termsAndConditionsLink: termsAndConditionsLink,
        shortPolicy: shortPolicy
      }));
      var doneDiv = React.createElement("div", {
        id: "email-capture-done"
      }, React.createElement("div", {
        className: styles.header
      }, React.createElement(SVGIcon, {
        name: "tag",
        className: styles.tagIcon
      }), React.createElement("h3", {
        className: styles.doneTitle
      }, gettext("account.register.return_lead.recently_viewed_items.step3_title")), React.createElement("div", {
        className: styles.doneSubtitle
      }, gettext("account.register.return_lead.recently_viewed_items.step3_subtitle"))), React.createElement(Button, {
        styleType: "tertiary",
        onClick: this.onContinueShoppingClick,
        fullWidth: true
      }, gettext("account.register.return_lead.recently_viewed_items.step3_btn")));
      return React.createElement("div", {
        id: "email-capture-overlay",
        ref: this.appElement
      }, React.createElement(Modal, {
        appElement: document.body,
        isOpen: overlayOpen,
        onRequestClose: this.onClose,
        className: styles.modal,
        overlayClassName: styles.overlay
      }, React.createElement(CloseButton, {
        className: styles.closeButton,
        onClick: this.onClose
      }), React.createElement("div", {
        className: styles.captureForm
      }, !showDone && form, showDone && doneDiv)));
    }
  }]);

  return RecentlyViewedEmailCapture;
}(React.Component);
export default RecentlyViewedEmailCapture;
RecentlyViewedEmailCapture.propTypes = {
  cookiePolicyLink: PropTypes.string,
  desktopVersionEnabled: PropTypes.bool,
  privacyPolicyLink: PropTypes.string,
  termsAndConditionsLink: PropTypes.string,
  shortPolicy: PropTypes.bool
};